import { Route, Routes } from "react-router-dom";

import { ScrollToTop } from "./components/ScrollToTop";
import { SiteFooter } from "./components/SiteFooter";
import { SiteHeader } from "./components/SiteHeader";
import { features } from "./lib/site";
import { ContactPage } from "./pages/ContactPage";
import { HomePage } from "./pages/HomePage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { PortfolioPage } from "./pages/PortfolioPage";

export const App = () => (
  <div className="app-shell">
    <ScrollToTop />
    <a className="skip-link" href="#main">
      Skip to content
    </a>
    <SiteHeader />
    <main id="main" className="app-shell__main">
      <Routes>
        <Route path="/" element={<HomePage />} />
        {features.portfolio ? (
          <Route path="/portfolio" element={<PortfolioPage />} />
        ) : null}
        <Route path="/contact" element={<ContactPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </main>
    <SiteFooter />
  </div>
);
